<input type="text" dynamicDigitBeforeAndDynamicDigitAfterDecimalNumber [beforeDecimal]="6" [afterDecimal]="4"
   appBlockCopyPaste
   class="w-80pc date-right-panel border text-right  bg-white rounded padding-left-5 padding-bottom-10 text-renderer padding-right5"
   [ngClass]="{'border-danger red-placeholder': errReq == true,'border-secondary': errReq!=true}" value={{value}}
   placeholder="{{placeholdertext}}" [(ngModel)]="value" (input)="onInput($event)" (change)="onChange($event)" autocomplete="off"
   maxlength="11" min="0.0001" max="999999.9999">
